// @owners { team: patients }
import { ActionSheetContext, Description, Link } from '@alto/design-system';
import React, { useContext } from 'react';
import { PRESCRIPTION_PRICING_LABELS } from '~shared/features/pricing/constants';
import { PricePendingActionSheet } from '../PricePendingActionSheet';

export const UnavailablePriceDescription = ({
  isPostCheckout,
  prescriptionID,
}: {
  readonly isPostCheckout: boolean;
  readonly prescriptionID: number;
}) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  return (
    <Description>
      {PRESCRIPTION_PRICING_LABELS.PRICE_UNAVAILABLE} •{' '}
      <Link
        textSize="mini"
        onPress={() => {
          setActiveActionSheet(
            <PricePendingActionSheet
              orderTypeContext={isPostCheckout ? 'Post checkout' : 'Checkout'}
              prescriptionID={prescriptionID}
            />,
          );
        }}
      >
        Details
      </Link>
    </Description>
  );
};
